import React from 'react';
import PropTypes from 'prop-types';

import { PromoCodeForm } from './promo_code_form.jsx';

export class PromoCodeListItem extends React.Component {
  static propTypes = {
    availableTicketClasses: PropTypes.array,
    showEditor: PropTypes.bool,
    onChange: PropTypes.func,
    onDelete: PropTypes.func,
    onAddTicketClass: PropTypes.func,
    onRemoveTicketClass: PropTypes.func,
    onToggleEditor: PropTypes.func
  };

  static defaultProps = {
    showEditor: false
  };

  constructor(...args) {
    super(...args);
    this.toggleEditForm = this.toggleEditForm.bind(this);
    this.closeForm = this.closeForm.bind(this);
    this.formChange = this.formChange.bind(this);
    this.deleteTicket = this.deleteTicket.bind(this);
  }

  toggleEditForm(event) {
    event.preventDefault();
    return (typeof this.props.onToggleEditor === 'function' ? this.props.onToggleEditor(this.props.promoCode.id) : undefined);
  }

  closeForm(event) {
    event.preventDefault();
    return (typeof this.props.onToggleEditor === 'function' ? this.props.onToggleEditor(this.props.promoCode.id, false) : undefined);
  }

  formChange(name, value, event) {
    return (typeof this.props.onChange === 'function' ? this.props.onChange(this.props.promoCode.id, name, value, event) : undefined);
  }

  deleteTicket(event) {
    event.preventDefault();
    return (typeof this.props.onDelete === 'function' ? this.props.onDelete(this.props.promoCode.id, event) : undefined);
  }

  render() {
    const edit_form = this.props.showEditor ?
      <PromoCodeForm promoCode={this.props.promoCode}
                      settings={this.props.settings}
                      availableTicketClasses={this.props.availableTicketClasses}
                      onChange={this.formChange}
                      onClose={this.closeForm}
                      onAddTicketClass={this.props.onAddTicketClass}
                      onRemoveTicketClass={this.props.onRemoveTicketClass} /> : undefined;

    return <tbody>
      <tr>
        <td>{this.props.promoCode.code}</td>
        <td>
          {this.props.promoCode.total_usage || 0}
          {this.props.promoCode.usage_limit > 0 && ` / ${  this.props.promoCode.usage_limit}`}
        </td>
        <td>
          <div className="text-right action_icon_button">
            <a href="#"
               onClick={this.toggleEditForm}
               title="Edit Promo Code"
               className="edit_button"><i className="localist-icon-edit-small"></i></a>
            <a href="#"
               onClick={this.deleteTicket}
               title="Remove Promo Code"
               className="deletex_button"><i className="localist-icon-trash-small"></i></a>
          </div>
        </td>
      </tr>
      {edit_form}
    </tbody>;
  }
}
